import Vue from 'vue';
import Router from 'vue-router';
import Account from 'services/AccountService';


Vue.use(Router);

const login = resolve => require(['views/login.vue'], resolve);
const login2 = resolve => require(['views/login2.vue'], resolve);
const Forgetpassword = resolve => require(['../views/forgetpassword.vue'], resolve);
const Register = resolve => require(['views/register.vue'], resolve);
const WaitingVerify = resolve => require(['views/waitingverify.vue'], resolve);

const subview = resolve => require(['views/layout.vue'], resolve);

const MyProfile = resolve => require(['views/profile/myprofile.vue'], resolve);

const index = resolve => require(['views/index.vue'], resolve);
const Unit = resolve => require(['modules/unit/index.vue'], resolve);
const Questionnaire = resolve => require(['modules/questionnaire/questionnaire.vue'], resolve);
const NewQuestionnaire = resolve => require(['modules/questionnaire/newquestionnaire.vue'], resolve);


const QuestionnaireDetail = resolve => require(['modules/questionnaire/QuestionnaireDetail.vue'], resolve);
const QuestionnaireDetailIndex = resolve => require(['modules/questionnaire/detail/index'], resolve);
const QuestionnaireDetailQr = resolve => require(['modules/questionnaire/detail/Qr'], resolve);
const QuestionnaireDetailStatistics = resolve => require(['modules/questionnaire/detail/Statistics'], resolve);
const QuestionnaireDetailWinning = resolve => require(['modules/questionnaire/detail/Winning'], resolve);
const QuestionnaireDetailMembers = resolve => require(['modules/questionnaire/detail/Members'], resolve);
const QuestionnaireDetailExport = resolve => require(['modules/questionnaire/detail/Export'], resolve);

const DiyFormIndex = resolve => require(['modules/diyform/index'], resolve);
const DiyFormEdit = resolve => require(['modules/diyform/edit'], resolve);


const davidtest = resolve => require(['../views/test/david.vue'], resolve);
const demolist = resolve => require(['../views/test/demolist.vue'], resolve);

const subviewChildren = [
    {
        path: '/myprofile',
        name: 'myprofile',
        component: MyProfile
    },
    {
        path: '/index',
        name: 'index',
        redirect: {
            name: 'questionnaire'
        }
    },
    {
        path: '/unit',
        name: 'unit',
        component: Unit
    },
    {
        path: '/questionnaire',
        name: 'questionnaire',
        component: Questionnaire
    },
    {
        path: '/editqustionnaire/:id',
        name: 'editqustionnaire',
        component: NewQuestionnaire
    },
    {
        path: '/newquestionnaire',
        name: 'newquestionnaire',
        component: NewQuestionnaire
    },
    {
        path: 'diyform',
        name: 'DiyFormIndex',
        component: DiyFormIndex
    },
    {
        path: 'diyform/edit/:id?',
        name: 'DiyFormEdit',
        component: DiyFormEdit
    },

    {
        path: '',
        redirect: {
            name: 'questionnaire'
        }
    }

];


const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login2
        },
        {
            path: '/login/o2jJmGt1E',
            name: 'login2',
            component: login2
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/forgetpassword',
            name: 'forgetpassword',
            component: Forgetpassword
        },
        {
            path: '/waitingVerify',
            name: 'waitingVerify',
            component: WaitingVerify
        },
        {
            path: '/',
            meta: {requiresAuth: true},
            component: subview,
            children: subviewChildren
        },

        {
            path: '/questionnairedetail/:id',
            meta: {requiresAuth: true},
            component: QuestionnaireDetail,
            children: [
                {
                    path: '',
                    name: 'questionnaireDetail',
                    component: QuestionnaireDetailIndex
                },
                {
                    path: 'qr',
                    name: 'QuestionnaireDetailQr',
                    component: QuestionnaireDetailQr
                },
                {
                    path: 'st',
                    name: 'QuestionnaireDetailStatistics',
                    component: QuestionnaireDetailStatistics
                },
                {
                    path: 'winning',
                    name: 'QuestionnaireDetailWinning',
                    component: QuestionnaireDetailWinning
                },
                {
                    path: 'members',
                    name: 'QuestionnaireDetailMembers',
                    component: QuestionnaireDetailMembers
                },
                {
                    path: 'export',
                    name: 'QuestionnaireDetailExport',
                    component: QuestionnaireDetailExport
                },
            ]
        },
        //测试
        {
            path: '/davidtest',
            name: 'davidtest',
            component: davidtest
        },
        //演示
        {
            path: '/demolist',
            name: 'demolist',
            component: demolist
        },
        {
            path: '*',
            redirect: {
                name: 'questionnaire'
            }
        }
    ]
});
router.beforeEach((to, from, next) => {
    if (to.name === 'login' || /.*test.*/.test(to.name)) {
        next();
        return;
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (Account.checklogin()) {
            if (Account.hasProfile()) {
                next();
            } else {
                Account.initAccount().then(() => {
                    next();
                })
            }
        } else {
            next({
                name: 'login'
                // query: {redirect: to.fullPath}
            });
        }
    } else {
        next(); //确保一定要调用 next()
    }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js